export enum IoEventTypes {
    CHANNELS_VALUES_UPDATED = 'channel-values-updated',
    CHANNEL_UPDATED = 'channel-updated',
}

export enum ShipyardEvents {
    CREATE_SHIPYARD = 'shipyard-created',
    DELETE_SHIPYARD = 'shipyard-deleted',
    UPDATE_SHIPYARD = 'shipyard-updated',
}

export enum VesselEvents {
    CREATE_VESSEL = 'vessel-created',
    DELETE_VESSEL = 'vessel-deleted',
    UPDATE_VESSEL = 'vessel-updated',
}

export enum NotificationsEvents {
    NOTIFICATION_UPDATED = 'notification-updated',
}

export enum AccessRequestEvents {
    ACCESS_REQUESTED = 'access-requested',
    ACCESS_REQUEST_UPDATED = 'access-request-updated',
    GUEST_START_EDIT = 'guest-start-edit',
    GUEST_FINISH_EDIT = 'guest-finish-edit',
    GUEST_REMOVED_EDIT = 'guest-removed-edit',
    GUEST_LEFT_EDIT = 'guest-left-edit',
    ACCESS_REQUEST_CANCELED = 'access-request-canceled',
}

export enum PublishRequestEvents {
    REQUEST_ACCEPTED = 'publish-request-accepted',
    REQUEST_REJECTED = 'publish-request-rejected',
    PUBLISH_CREATED = 'publish-created',
    PUBLISH_APPROVED = 'publish-approved',
    PUBLISH_REJECTED = 'publish-rejected',
}

export enum MimicsEvents {
    MIMIC_CREATED = 'mimic-created',
    MIMIC_UPDATED = 'mimic-updated',
    MIMIC_DELETED = 'mimic-deleted',
    MIMIC_INDEX_UPDATE = 'mimic-index-updated',
}

export enum OpsUsersEvents {
    OPS_USERS_CREATED = 'ops-user-created',
    OPS_USERS_UPDATED = 'ops-user-updated',
    OPS_USERS_DELETED = 'ops-user-deleted',
    PERMISSIONS_UPDATED = 'ops-permissions-updated',
    SESSION_TIMEOUT_UPDATED = 'ops-timeout-updated',
}

export enum AlarmGroupEvents {
    ALARM_GROUPS_UPDATED = 'alarm-groups-updated',
}

export enum AlarmGroupSettingEvents {
    SETTINGS_UPDATED = 'alarm-group-settings-updated',
}

export enum ReposeGroupEvents {
    REPOSE_GROUPS_UPDATED = 'repose-groups-updated',
}

export enum SystemColorEvents {
    SYSTEM_COLOR_INIT = 'system-color-init',
    SYSTEM_COLOR_CREATED = 'system-color-created',
    SYSTEM_COLOR_UPDATED = 'system-color-updated',
    SYSTEM_COLOR_DELETED = 'system-color-deleted',
}

export enum GraphsEvents {
    GRAPH_CREATED = 'graph-created',
    GRAPH_DELETED = 'graph-deleted',
    GRAPH_UPDATED = 'graph-updated',
    GRAPH_REORDERED = 'graph-reordered',
}

export enum ExhaustGasGraphEvents {
    TABLE_UPDATED = 'exhaust-gas-graph-table-updated',
}

export enum GaugeGraphEvents {
    TABLE_UPDATED = 'gauge-graph-table-updated',
}

export enum BarGraphEvents {
    TABLE_UPDATED = 'bar-graph-table-updated',
}

export enum CommonEvents {
    COMMON_CREATED = 'common-created',
    COMMON_DELETED = 'common-deleted',
    COMMON_UPDATED = 'common-updated',
}

export enum OpsUnitEvents {
    OPS_UNIT_CREATED = 'ops-unit-created',
    OPS_UNIT_DELETED = 'ops-unit-deleted',
    OPS_UNIT_UPDATED = 'ops-unit-updated',
    OPS_UNIT_DUPLICATED = 'ops-unit-duplicated',
}

export enum EapEvents {
    EAP_CREATED = 'eap-created',
    EAP_UPDATED = 'eap-updated',
    EAP_TABLE_UPDATED = 'eap-table-updated',
    LED_PATTERN_CREATED = 'led-pattern-created',
    LED_PATTERN_UPDATED = 'led-pattern-updated',
    LED_PATTERN_DELETED = 'led-pattern-deleted',
}

export enum FcuEvents {
    FCU_UNIT_CREATED = 'fcu-unit-created',
    FCU_UNIT_DELETED = 'fcu-unit-deleted',
    FCU_UNIT_UPDATED = 'fcu-unit-updated',
    FCU_UNIT_DUPLICATED = 'fcu-unit-duplicated',
}

export enum SlotEvents {
    SLOT_CREATED = 'slot-created',
    SLOT_DELETED = 'slot-deleted',
    SLOT_UPDATED = 'slot-updated',
}

export enum FuEvents {
    FU_UNIT_CREATED = 'fu-unit-created',
    FU_UNIT_DELETED = 'fu-unit-deleted',
    FU_UNIT_UPDATED = 'fu-unit-updated',
}

export enum ExternalCommunicationEvents {
    EXTERNAL_COMMUNICATION_CREATED = 'external-communication-created',
    EXTERNAL_COMMUNICATION_DELETED = 'external-communication-deleted',
    EXTERNAL_COMMUNICATION_UPDATED = 'external-communication-updated',
}

export enum CeuEvents {
    CEU_UNIT_CREATED = 'ceu-unit-created',
    CEU_UNIT_UPDATED = 'ceu-unit-updated',
    CEU_UNIT_DELETED = 'ceu-unit-deleted',
    PORTS_UPDATED = 'unit-ports-updated',
}

export enum LibraryEvents {
    LIBRARY_CREATED = 'library-created',
    LIBRARY_DELETED = 'library-deleted',
    LIBRARY_UPDATED = 'library-updated',
}

export enum LibraryCategoryEvents {
    LIBRARY_CATEGORY_CREATED = 'library-category-created',
    LIBRARY_CATEGORY_DELETED = 'library-category-deleted',
    LIBRARY_CATEGORY_UPDATED = 'library-category-updated',
}

export enum LibraryComponentEvents {
    LIBRARY_COMPONENT_CREATED = 'library-component-created',
    LIBRARY_COMPONENT_DELETED = 'library-component-deleted',
    LIBRARY_COMPONENT_UPDATED = 'library-component-updated',
}

export enum RunningHourEvents {
    RUNNING_HOUR_GROUP_UPDATED = 'running-hour-updated',
}

export enum ElementConditionEvents {
    ELEMENT_CONDITION_CREATED = 'element-condition-created',
    ELEMENT_CONDITION_DELETED = 'element-condition-deleted',
    ELEMENT_CONDITION_UPDATED = 'element-condition-updated',
}

export enum ElementConditionLogicEvents {
    ELEMENT_CONDITION_LOGIC_CREATED = 'element-condition-logic-created',
    ELEMENT_CONDITION_LOGIC_DELETED = 'element-condition-logic-deleted',
    ELEMENT_CONDITION_LOGIC_UPDATED = 'element-condition-logic-updated',
}

export enum MatrixChannelEvents {
    MATRIX_CHANNEL_CREATED = 'matrix-channel-created',
    MATRIX_CHANNEL_DELETED = 'matrix-channel-deleted',
    MATRIX_CHANNEL_UPDATED = 'matrix-channel-updated',
}

export enum ElementIntegrationEvents {
    ELEMENT_INTEGRATION_CREATED = 'element-integration-created',
    ELEMENT_INTEGRATION_DELETED = 'element-integration-deleted',
    ELEMENT_INTEGRATION_UPDATED = 'element-integration-updated',
}

export enum ExhaustGasSettingEvents {
    UPDATED = 'exhaust-gas-setting-updated',
}

export enum SensorCableTagEvents {
    UPDATED = 'sensor-cable-tag-updated',
}

export enum MimicFolderEvents {
    MIMIC_FOLDER_CREATED = 'mimic-folder-created',
    MIMIC_FOLDER_DELETED = 'mimic-folder-deleted',
    MIMIC_FOLDER_UPDATED = 'mimic-folder-updated',
    MIMIC_FOLDER_INDEX_UPDATE = 'mimic-folder-index-updated',
}

export enum DutyEngineerEvents {
    DUTY_ENGINEER_CREATED = 'duty-engineer-created',
    DUTY_ENGINEER_UPDATED = 'duty-engineer-updated',
    DUTY_ENGINEER_DELETED = 'duty-engineer-deleted',
    DUTY_ENGINEER_REORDERED = 'duty-engineer-reordered',
}

export enum DutyEngineerCategoryEvents {
    DUTY_ENGINEER_CATEGORY_UPDATED = 'duty-engineer-category-updated',
}

export enum OutputSettingsEvents {
    ANALOG_SETTINGS_UPDATED = 'analog-settings-updated',
    DIGITAL_SETTING_UPDATED = 'digital-setting-updated',
    DIGITAL_SETTING_DELETED = 'digital-setting-deleted',
}

export enum DeviceManagmentEvents {
    DEVICE_UPDATED = 'device-updated',
    DEVICE_CREATED = 'device-created',
    DEVICE_DELETED = 'device-deleted',
    MODEL_UPDATED = 'model-updated',
    MODEL_CREATED = 'model-created',
    MODEL_DELETED = 'model-deleted',
    EQUIPMENT_UPDATED = 'vessel-equipment-updated',
}

export enum VesselOwnershipEvents {
    OWNERSHIP_REQUESTED = 'ownership-requested',
    OWNERSHIP_CLAIMED = 'ownership-claimed',
    OWNERSHIP_ASSIGNED = 'ownership-assigned',
    OWNERSHIP_REJECTED = 'ownership-rejected',
    OWNER_LEFT = 'owner-left',
    OWNER_REMOVED = 'owner-removed',
}

export enum SystemSpecificationEvents {
    SPECIFICATIONS_UPDATED = 'system-specifications-updated',
}

export enum CommunicationProtocolEvents {
    CREATED = 'communication-protocol-created',
    UPDATED = 'communication-protocol-updated',
    DELETED = 'communication-protocol-deleted',
}
